<template>
  <div
    class="card flex flex-col items-center justify-center gap-4 text-center hover:cursor-pointer"
    :class="{ 'opacity-50': props.disabled || isLoading }"
    @click="handleClick"
  >
    <template v-if="!isLoading">
      <component :is="icon" stroke="1.5" class="h-10 w-10" />
      <p class="select-none font-bold">{{ text }}</p>
    </template>

    <IconLoader2 v-else class="loader h-8 w-8 animate-spin" />
  </div>
</template>

<script setup lang="ts">
import type { Icon } from '@tabler/icons-vue'
import { IconLoader2 } from '@tabler/icons-vue'
import { ref } from 'vue'

export interface InfoCardProps {
  icon: Icon
  text: string
  callback?: () => Promise<unknown>
  disabled?: boolean
}

const props = defineProps<InfoCardProps>()

const isLoading = ref(false)

const setLoading = (value: boolean) => {
  isLoading.value = value
}

async function handleClick() {
  if (props.disabled || isLoading.value) return

  if (props.callback) {
    isLoading.value = true
    await props.callback()
    isLoading.value = false
  }
}

defineExpose({
  setLoading
})
</script>
